export default "__VITE_ASSET__CCPur1OL__"